import Curso from './Curso'
import Livro from './Livro'

export { Curso, Livro }



// WEBPACK FOOTER //
// ./src/containers/PreRegistration/PreRegistrationTypes/index.js